













































































import { Component, Prop, Vue } from "vue-property-decorator";
import QDatePicker from "@/components/Booking/QDatePicker.vue";
import { mapState } from "vuex";
import { SERVICE_ITEMS } from "@/constants/service_request";
import { changeTextColor } from "@/utils/color";

@Component({
  components: {
    QDatePicker
  },
  computed: {
    ...mapState("ServiceItem", {
      serviceItems: "serviceItems"
    })
  },
  methods: {
    changeTextColor
  }
})
export default class BookingCreateCandidateTableItem extends Vue {
  @Prop() readonly item!: Candidate;

  @Prop() readonly index!: number;

  @Prop() readonly disableRemove!: boolean;

  @Prop() readonly disableAction!: boolean;

  @Prop() readonly removeAction!: boolean;

  serviceItems!: Model[];

  showAdditionalService = false;

  get name() {
    if (!this.item.first_name && !this.item.last_name) {
      return null;
    }
    return (this.item.first_name ?? "") + " " + (this.item.last_name ?? "");
  }

  get additionalServices() {
    return this.serviceItems
      .filter(serviceItem => serviceItem.key !== "assessment")
      .map(serviceItem => {
        return {
          object_id: serviceItem.object_id,
          key: serviceItem.key,
          icon: SERVICE_ITEMS[serviceItem.key].icon,
          name: serviceItem.name
        };
      });
  }
}
